import { Trans } from "react-i18next";import { X } from "lucide-react";
import { cn } from "../../../lib/utils";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle } from
"../../../components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";

export function WithdrawDialog({
  open,
  onOpenChange,
  onConfirm,
  actionType = "withdraw",
  loading = false,
  error = ""
}) {
  const isRevoke = actionType === "revoke";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]",
            "w-[95vw] sm:w-[90vw] md:w-[480px] max-w-[480px]",
            "max-h-[90vh] overflow-hidden flex flex-col",
            "bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60",
            "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
            "font-sans"
          )}>
          
          <div className="flex items-center justify-between px-6 py-3.5 border-b border-[var(--color-text-border)]/70 shrink-0">
            <DialogTitle className="text-[20px] font-semibold text-foreground tracking-tight">
              {isRevoke ? "Revoke Leave Request" : "Withdraw Leave Request"}
            </DialogTitle>
            <DialogPrimitive.Close className="h-9 w-9 grid place-items-center rounded-xl text-[var(--color-text-secondary)] hover:bg-[var(--color-workspace)]/60 hover:text-[var(--color-primary)] transition">
              <X className="h-5 w-5" />
              <span className="sr-only"><Trans i18nKey="formActions.close" /></span>
            </DialogPrimitive.Close>
          </div>
          <div className="px-6 py-5 overflow-y-auto flex-1">
            {isRevoke ?
            <div className="py-4 text-center">
                <p className="text-base font-semibold text-foreground"><Trans i18nKey="leave.featureComingSoon" /></p>
                <p className="mt-2 text-sm text-[var(--color-text-secondary)] leading-relaxed">
                  <Trans i18nKey="leave.leaveRevocationWillBeAvailableInAFuture" />
                </p>
              </div> :

            <>
                <p className="text-sm text-[var(--color-text-secondary)] leading-relaxed">
                  <Trans i18nKey="leave.areYouSureYouWantToWithdrawThis" />
                </p>
                {error ?
              <p className="mt-3 text-sm text-[var(--color-error)] font-medium">{error}</p> :
              null}
              </>
            }
            {/*
              Original revoke confirmation copy (preserved for re-enable):
              {isRevoke
               ? "Are you sure you want to revoke this approved leave request?"
               : "Are you sure you want to withdraw this leave request?"}
              */}
          </div>
          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 px-6 py-4 border-t border-[var(--color-text-border)]/70 shrink-0">
            {isRevoke ?
            <DialogPrimitive.Close className="h-11 px-5 rounded-xl bg-[var(--color-primary)] text-white text-sm font-semibold hover:opacity-90 transition cursor-pointer">
                <Trans i18nKey="formActions.close" />
              </DialogPrimitive.Close> :

            <button
              onClick={onConfirm}
              disabled={loading}
              className={cn(
                "h-11 px-5 rounded-xl text-white text-sm font-semibold hover:opacity-90 transition cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
                "bg-[var(--color-error)] shadow-[0_8px_20px_-8px_rgba(239,68,68,0.5)]"
              )}>
              
                {loading ? "Withdrawing..." : "Confirm Withdrawal"}
              </button>
            }
            {/*
              Original revoke confirm button (preserved for re-enable):
              <button
               onClick={onConfirm}
               disabled={loading}
               className="h-11 px-5 rounded-xl bg-[var(--color-warning)] text-white text-sm font-semibold ..."
              >
               {loading ? "Revoking..." : "Confirm Revocation"}
              </button>
              */}
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>);

}
